module.exports = __webpack_public_path__ + "static/media/screen-comoto.2484fd60.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/WorksSection/screens/screen-comoto.png
// module id = 325
// module chunks = 0